import { approach } from './approach'
import { contactPanel } from './contact-panel'
import { footer } from './footer'
import { hero } from './hero'
import { industries } from './industries'
import { intro } from './intro'
import { navigation } from './navigation'
import { privacyPolicy } from './privacy-policy'
import { services } from './services'
import { team } from './team'
import type { WebsiteContent } from './types'

export type { WebsiteContent } from './types'

export const websiteContent: WebsiteContent = {
  navigation,
  hero,
  intro,
  approach,
  services,
  industries,
  team,
  footer,
  contactPanel,
  privacyPolicy,
}
